import { t as ZepIcon } from "../ZepIcon-DpJgyrAI.mjs";
import { jsx } from "react/jsx-runtime";
// src/components/InformationmarkSmallCircleFill.tsx
const DEFAULT_COLOR = "#7A7B89";
const InformationmarkSmallCircleFillIcon = ZepIcon(({ color = DEFAULT_COLOR, fill, ...props }) => /* @__PURE__ */ jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	color,
	...props,
	children: /* @__PURE__ */ jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Zm0-16a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Zm-1 12v-8h2v8h-2Z",
		fill: fill || "currentColor"
	})
}));
export { InformationmarkSmallCircleFillIcon };
